import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
    {
        n: "01",
        slug: "estate-planning",
        title: "Estate Planning",
        body: "Wills, revocable trusts, powers of attorney, and farm-succession plans built so the next generation isn’t handed a problem.",
        to: "/estate-planning"
    },
    {
        n: "02",
        slug: "elder-law",
        title: "Elder Law",
        body: "Long-term care planning, Medicaid and VA benefits, special needs trusts, and the documents that carry the load when they need to.",
        to: "/elder-law"
    },
    {
        n: "03",
        slug: "real-estate-law",
        title: "Real Estate Law",
        body: "Purchases, sales, leases, boundary issues, and zoning across rural and commercial properties, from a quarter-section to a downtown storefront.",
        to: "/real-estate-law"
    },
    {
        n: "04",
        slug: "business-law",
        title: "Business Law",
        body: "LLCs and corporations, operating agreements, contracts, and day-to-day counsel for farms, family enterprises, and Main-Street businesses.",
        to: "/business-law"
    }
];

export default function ServicesSection() {
    return (
        <section
            data-testid="services-section"
            className="relative py-24 lg:py-36 bg-white border-t border-acre-line"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16 lg:mb-20">
                    <div className="lg:col-span-5">
                        <div className="flex items-center mb-6">
                            <span className="acre-tick" />
                            <span className="text-[11px] uppercase tracking-[0.28em] text-acre-muted">
                                Practice Areas
                            </span>
                        </div>
                        <h2 className="font-serif-display text-4xl lg:text-6xl tracking-tight leading-[1.02] text-acre-secondary">
                            Practice areas.
                        </h2>
                    </div>
                </div>

                <ul className="divide-y divide-acre-line border-y border-acre-line">
                    {SERVICES.map((s) => (
                        <li key={s.slug}>
                            <Link
                                to={s.to}
                                data-testid={`service-row-${s.slug}`}
                                className="group grid grid-cols-12 gap-4 lg:gap-8 py-8 lg:py-10 items-start hover:bg-[#FBFBFB] transition-colors"
                            >
                                <div className="col-span-2 lg:col-span-1 font-serif-display text-2xl lg:text-3xl text-acre-secondary leading-none pt-1">
                                    {s.n}
                                </div>
                                <div className="col-span-10 lg:col-span-4">
                                    <h3 className="font-serif-display text-3xl lg:text-4xl text-acre-ink leading-tight group-hover:text-acre-secondary transition-colors">
                                        {s.title}
                                    </h3>
                                </div>
                                <div className="col-span-12 lg:col-span-6 mt-2 lg:mt-0">
                                    <p className="text-acre-muted text-base leading-relaxed max-w-xl">
                                        {s.body}
                                    </p>
                                </div>
                                <div className="col-span-12 lg:col-span-1 flex lg:justify-end mt-2 lg:mt-0">
                                    <ArrowUpRight
                                        size={22}
                                        strokeWidth={1.5}
                                        className="text-acre-ink group-hover:text-acre-secondary group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                                    />
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
